





















































































import { Vue, Component } from 'vue-property-decorator';
import TableLayout from '@/components/swine/layout/TableLayout.vue';
import Pagination from '@/components/swine/Pagination.vue';
import { Emit, Prop } from 'vue-property-decorator';
import { User } from '@/models/swine/user/user.model';
import {
  RowCountChange,
  PageNumberChange,
} from '@/models/swine/pagination.model';
import { Country } from '@/models/swine/country/country.model';
import { Module } from '@/models/general/module/module.model';
@Component({
  components: {
    TableLayout,
    Pagination,
  },
})
export default class UserTable extends Vue {
  @Prop({
    type: Array,
    default: [],
  })
  userList!: User[];

  @Prop({
    type: Number,
    default: 0,
  })
  totalCount!: number;

  @Prop({
    type: Number,
    default: 1,
  })
  pageNumber!: number;

  @Prop({
    type: Number,
    default: 10,
  })
  rowsPerPage!: number;

  editUser(id: string) {
    this.$router.push({
      name: 'EditUser',
      params: {
        userId: id,
      },
    });
  }

  @Emit('sort')
  sortPressed(field: string, order: 'asc' | 'desc') {
    return `${field}:${order}`;
  }

  @Emit('rowCountChange')
  updateRowCount(params: RowCountChange) {
    return params;
  }

  @Emit('pageNumberChange')
  updatePageNumber(params: PageNumberChange) {
    return params;
  }

  setCountryItem(prop: Country | null) {
    return !prop ? 'None' : prop.name;
  }

  setSpeciesItem(prop: Module[] | null) {

    if (prop) {
      return prop.map((data) => {
        return data.speciesName;
      }).join(' & ');
    }

    return '';
  }
}
